// extracted by mini-css-extract-plugin
export default {"Emojify":"bbk_a bhk_g"};